module.exports = __webpack_public_path__ + "img/HITACHI-icon.8973e89a.png";